enum FundingType {
    NotSet = 0,
    Cash = 1,
    Loan = 2,
    Remortgage = 3,
    NotSure = 4
}

export default FundingType;
